<template>
  <sidepanel v-if="$route.name === routeNames.sidepanel" />
  <div
    v-else-if="loading"
    class="app-spinner"
  >
    <c-icon
      type="loading"
      spin
      size="28"
      :color="$colors.grey.lighten1"
    />
  </div>
  <login-view v-else-if="!loading && currentUser === null && $route.meta.auth !== false" />
  <div v-else-if="$route.meta.layout === 'plain'">
    <router-view />
  </div>
  <router-view v-else-if="$route.meta.auth === false" />
  <div
    v-else
    class="_router-view"
  >
    <side-bar />
    <div
      class="_container"
    >
      <router-view />
    </div>
  </div>
  <c-toast />
</template>

<script>
import CIcon from 'shared/components/CIcon.vue';
import CToast from 'shared/components/CToast.vue';
import { FIREBASE_APP, SUBSCRIPTION_MANAGER, USER_SERVICE } from 'shared/constants';
import useCurrentUser from 'shared/services/user';
import { inject, provide } from 'vue';

import SideBar from '@/components/SideBar.vue';
import routeNames from '@/router/routes';
import LoginView from '@/views/LoginView.vue';
import Sidepanel from '@/views/Sidepanel.vue';

export default {
  name: 'App',
  setup() {
    const firebaseApp = inject(FIREBASE_APP);
    const subscriptionManager = inject(SUBSCRIPTION_MANAGER);
    const userService = useCurrentUser(firebaseApp.db, subscriptionManager);

    provide(USER_SERVICE, userService);

    return { currentUser: userService.currentUser, loading: userService.loading };
  },
  components: { CToast, SideBar, LoginView, CIcon, Sidepanel },
  data() {
    return { routeNames };
  },
};

</script>
<style
    type="text/scss"
    lang="scss"
>
  @import "assets/scss/index";

  html {
    margin: 0;
    font-size: 62.5%;
    /* stylelint-disable property-no-vendor-prefix -- text-size-adjust is
       only supported prefixed; dropping these changes mobile rendering. */
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    /* stylelint-enable property-no-vendor-prefix */
    -ms-overflow-style: scrollbar;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  body {
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'SF Pro Display', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
    font-size: $font-size-4;
    -webkit-font-smoothing: subpixel-antialiased;
    /* stylelint-disable property-no-vendor-prefix -- text-size-adjust is
       only supported prefixed; dropping these changes mobile rendering. */
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
    /* stylelint-enable property-no-vendor-prefix */
    font-weight: 400;
    font-variant: tabular-nums;
    line-height: 1.5;
    font-feature-settings: "tnum";
    background-color: #FFFEFC;
    color: $font-color-primary;
  }

  .app-spinner {
    height: 100vh;
    width: 100vw;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  ._router-view {
    height: 100vh;
    width: 100vw;
    display: flex;
    background-color: white;

    ._container {
      width: 100%;
      overflow: auto;
    }
  }
</style>
